import React, { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const FinancialReport = React.lazy(() => import('./FinancialReport'));

function EventFinancialReport(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>گزارش مالی رویداد</PageTitle>
        <Link to="/events">بازگشت به لیست رویدادها</Link>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <FinancialReport slug={props.match.params.slug} />
      </Suspense>
    </Page>
  );
}

export default EventFinancialReport;
